﻿export enum ProductlistType {
    Undefined = 0,
    Public = 1,
    Private = 2
}